import { httpGet, httpPost, httpPut, httpDelete } from '../core/restClient'
import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
// import { appLoading, appLoaded, toastError, toastSuccess } from './app'

const GET_COMPANY_DATA = makeKeys('GET_COMPANY_DATA')
const GET_MP_PURCHASING_GROUPS = makeKeys('GET_MP_PURCHASING_GROUPS')
const GET_MP_COMPANY_PLANTS = makeKeys('GET_MP_COMPANY_PLANTS')
const GET_MP_PLANT_STORAGE_LOCATIONS = makeKeys('GET_MP_PLANT_STORAGE_LOCATIONS')
const GET_MP_PR_ITEM_FIELDS = makeKeys('GET_MP_PR_ITEM_FIELDS')
const GET_MP_ORDER_GL_ACCOUNT = makeKeys('GET_MP_ORDER_GL_ACCOUNT')
const CREATE_MP_ORDER_GL_ACCOUNT = 'CREATE_MP_ORDER_GL_ACCOUNT'
const UPDATE_MP_ORDER_GL_ACCOUNT = 'UPDATE_MP_ORDER_GL_ACCOUNT'
const DELETE_MP_ORDER_GL_ACCOUNT = 'DELETE_MP_ORDER_GL_ACCOUNT'
const SET_FORM_ORDER_GL_ACCOUNT = 'SET_FORM_ORDER_GL_ACCOUNT'
const GET_MP_WBS_ASSETS = makeKeys('GET_MP_WBS_ASSETS')
const CREATE_MP_WBS_ASSET = 'CREATE_MP_WBS_ASSET'
const UPDATE_MP_WBS_ASSET = 'UPDATE_MP_WBS_ASSET'
const DELETE_MP_WBS_ASSET = 'DELETE_MP_WBS_ASSET'
const SET_FORM_WBS_ASSET = 'SET_FORM_WBS_ASSET'
const GET_ASSET_TYPES =  makeKeys('GET_ASSET_TYPES')
const GET_ALL_WBS =  makeKeys('GET_ALL_WBS')

export const getCompanyData = makeAction(GET_COMPANY_DATA.REQUEST, 'companyCode')
export const getMappingPurchasingGroups = makeAction(GET_MP_PURCHASING_GROUPS.REQUEST)
export const getMappingCompanyPlants = makeAction(GET_MP_COMPANY_PLANTS.REQUEST)
export const getMappingPlantStorageLocations = makeAction(GET_MP_PLANT_STORAGE_LOCATIONS.REQUEST)
export const getMappingPrItemFields = makeAction(GET_MP_PR_ITEM_FIELDS.REQUEST, 'retry')
export const getMappingOderGlAccounts = makeAction(GET_MP_ORDER_GL_ACCOUNT.REQUEST, 'withInactive', 'retry')
export const createMappingOderGlAccount = makeAction(CREATE_MP_ORDER_GL_ACCOUNT, 'data', 'onSuccess')
export const updateMappingOderGlAccount = makeAction(UPDATE_MP_ORDER_GL_ACCOUNT, 'data', 'onSuccess')
export const deleteMappingOderGlAccount = makeAction(DELETE_MP_ORDER_GL_ACCOUNT, 'id', 'onSuccess')
export const setFormOrderGlAccount = makeAction(SET_FORM_ORDER_GL_ACCOUNT, 'data')
export const getMappingWbsAssets = makeAction(GET_MP_WBS_ASSETS.REQUEST, 'withInactive', 'retry')
export const createMappingWbsAsset = makeAction(CREATE_MP_WBS_ASSET, 'data', 'onSuccess')
export const updateMappingWbsAsset = makeAction(UPDATE_MP_WBS_ASSET, 'data', 'onSuccess')
export const deleteMappingWbsAsset = makeAction(DELETE_MP_WBS_ASSET, 'id', 'onSuccess')
export const setFormWbsAsset = makeAction(SET_FORM_WBS_ASSET, 'data')
export const getAssetTypes = makeAction(GET_ASSET_TYPES.REQUEST, 'withInactive', 'retry')
export const getAllWbs = makeAction(GET_ALL_WBS.REQUEST, 'retry')

const getMappingPurchasingGroupsSuccess = makeAction(GET_MP_PURCHASING_GROUPS.SUCCESS, 'data')
const getMappingCompanyPlantsSuccess = makeAction(GET_MP_COMPANY_PLANTS.SUCCESS, 'data')
const getCompanyDataSuccess = makeAction(GET_COMPANY_DATA.SUCCESS, 'data')
const getMappingPlantStorageLocationsSuccess = makeAction(GET_MP_PLANT_STORAGE_LOCATIONS.SUCCESS, 'data')
const getMappingPrItemFieldsSuccess = makeAction(GET_MP_PR_ITEM_FIELDS.SUCCESS, 'data')
const getMappingOderGlAccountsSuccess = makeAction(GET_MP_ORDER_GL_ACCOUNT.SUCCESS, 'data', 'withInactive')
const getMappingWbsAssetsSuccess = makeAction(GET_MP_WBS_ASSETS.SUCCESS, 'data', 'withInactive')
const getAssetTypesSuccess = makeAction(GET_ASSET_TYPES.SUCCESS, 'data')
const getAllWbsSuccess = makeAction(GET_ALL_WBS.SUCCESS, 'data')

const getMappingPrItemFieldsFailure = makeAction(GET_MP_PR_ITEM_FIELDS.FAILURE)

function* getMappingPurchasingGroupsRequest(action) {
  try {
    const response = yield httpGet('mappingData/purchasingGroups')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingPurchasingGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getMappingPurchasingGroupsSuccess([]))
  }
}

function* getMappingCompanyPlantsRequest(action) {
  try {
    const response = yield httpGet('mappingData/companyPlants')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingCompanyPlantsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getMappingCompanyPlantsSuccess([]))
  }
}

function* getCompanyDataRequest(action) {
  const { companyCode } = action.payload
  try {
    const response = yield httpGet(`mappingData/companyData/${companyCode}`)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCompanyDataSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getCompanyDataSuccess([]))
  }
}

function* getMappingPlantStorageLocationsRequest(action) {
  try {
    const response = yield httpGet('mappingData/plantStorageLocations')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingPlantStorageLocationsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getMappingPlantStorageLocationsSuccess([]))
  }
}

function* getMappingPrItemFieldsRequest(action) {
  const { retry } = action.payload
  try {
    const response = yield httpGet('mappingData/prItemMappings')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingPrItemFieldsSuccess(response.data))
      }
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getMappingPrItemFieldsFailure())
    } else {
      yield put(getMappingPrItemFields(retry ? (retry + 1) : 1))
    }
  }
}

function* getMappingOderGlAccountsRequest(action) {
  let { withInactive, retry } = action.payload
  if (!withInactive) withInactive = false
  try {
    const response = yield httpGet('mappingData/orderGLAccounts', { withInactive })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingOderGlAccountsSuccess(response.data, withInactive))
      }
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getMappingOderGlAccountsSuccess([], withInactive))
    } else {
      yield put(getMappingOderGlAccounts(withInactive, retry ? (retry + 1) : 1))
    }
  }
}

function* createMappingOderGlAccountsRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Create mapping data.'))
    const response = yield httpPost('mappingData/orderGLAccounts', { ...data })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Create mapping data success'))
      yield put(getMappingOderGlAccounts(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateMappingOderGlAccountsRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Update mapping data.'))
    const response = yield httpPut(`mappingData/orderGLAccounts/${data.id}`, { ...data })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Update mapping data success'))
      yield put(getMappingOderGlAccounts(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* deleteMappingOderGlAccountsRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Delete mapping data.'))
    const response = yield httpDelete(`mappingData/orderGLAccounts/${id}`)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Delete mapping data success'))
      yield put(getMappingOderGlAccounts(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* getMappingWbsAssetsRequest(action) {
  let { withInactive, retry } = action.payload
  if (!withInactive) withInactive = false
  
  try {
    const response = yield httpGet('mappingData/wbsAssets', { withInactive })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMappingWbsAssetsSuccess(response.data, withInactive))
      }
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getMappingWbsAssetsSuccess([], withInactive))
    } else {
      yield put(getMappingWbsAssets(withInactive, retry ? (retry + 1) : 1))
    }
  }
}

function* createMappingWbsAssetRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Create mapping data.'))
    const response = yield httpPost('mappingData/wbsAssets', { ...data })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Create mapping data success'))
      yield put(getMappingWbsAssets(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateMappingWbsAssetRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Update mapping data.'))
    const response = yield httpPut(`mappingData/wbsAssets/${data.id}`, { ...data })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Update mapping data success'))
      yield put(getMappingWbsAssets(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* deleteMappingWbsAssetRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Delete mapping data.'))
    const response = yield httpDelete(`mappingData/wbsAssets/${id}`)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Delete mapping data success'))
      yield put(getMappingWbsAssets(true))
      onSuccess()
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete mapping data error!'))
    }
    yield put(appLoaded())
  }
}

function* getAssetTypesRequest(action) {
  let { withInactive, retry } = action.payload
  if (!withInactive) withInactive = false
  try {
    const response = yield httpGet('mappingData/assetTypes', { withInactive })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAssetTypesSuccess(response.data))
      }
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getAssetTypesSuccess([]))
    } else {
      yield put(getAssetTypes(retry ? (retry + 1) : 1))
    }
  }
}

function* getAllWbsRequest(action) {
  let { retry } = action.payload

  try {
    const response = yield httpGet('share/master/wbsElements')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAllWbsSuccess(response.data))
      }
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getAllWbsSuccess([]))
    } else {
      yield put(getAllWbs(retry ? (retry + 1) : 1))
    }
  }
}

export function* watchMappingDataSaga() {
  yield takeLatest(GET_MP_PURCHASING_GROUPS.REQUEST, getMappingPurchasingGroupsRequest)
  yield takeLatest(GET_MP_COMPANY_PLANTS.REQUEST, getMappingCompanyPlantsRequest)
  yield takeLatest(GET_COMPANY_DATA.REQUEST, getCompanyDataRequest)
  yield takeLatest(GET_MP_PLANT_STORAGE_LOCATIONS.REQUEST, getMappingPlantStorageLocationsRequest)
  yield takeLatest(GET_MP_PR_ITEM_FIELDS.REQUEST, getMappingPrItemFieldsRequest)
  yield takeLatest(GET_MP_ORDER_GL_ACCOUNT.REQUEST, getMappingOderGlAccountsRequest)
  yield takeLatest(CREATE_MP_ORDER_GL_ACCOUNT, createMappingOderGlAccountsRequest)
  yield takeLatest(UPDATE_MP_ORDER_GL_ACCOUNT, updateMappingOderGlAccountsRequest)
  yield takeLatest(DELETE_MP_ORDER_GL_ACCOUNT, deleteMappingOderGlAccountsRequest)
  yield takeLatest(GET_MP_WBS_ASSETS.REQUEST, getMappingWbsAssetsRequest)
  yield takeLatest(CREATE_MP_WBS_ASSET, createMappingWbsAssetRequest)
  yield takeLatest(UPDATE_MP_WBS_ASSET, updateMappingWbsAssetRequest)
  yield takeLatest(DELETE_MP_WBS_ASSET, deleteMappingWbsAssetRequest)
  yield takeLatest(GET_ASSET_TYPES.REQUEST, getAssetTypesRequest)
  yield takeLatest(GET_ALL_WBS.REQUEST, getAllWbsRequest)
}

const initial = {
  purchasingGroups: { data: [], loading: false },
  companyPlants: { data: [], loading: false },
  companyData: { data: {}, loading: false },
  plantStorageLocations: { data: [], loading: false },
  allOrderGlAccounts: { data: [], loading: false },
  orderGlAccounts: { data: [], loading: false },
  wbsAssets: { data: [], loading: false },
  allWbsAssets: { data: [], loading: false },
  assetTypes: { data: [], loading: false },
  allWbs: { data: [], loading: false },
  prItemFields: { 
    data: {
      itemName: { '': { require: true, display: 'edit' } },
      itemDescription: { '': { require: false, display: 'edit' } },
      quantity: { '': { require: true, display: 'edit' } },
      unit: { '': { require: true, display: 'edit' } },
      unitPrice: { '': { require: true, display: 'edit' } },
      totalAmount: { '': { require: true, display: 'show' } },
      currency: { '': { require: true, display: 'edit' } },
      startDate: { '': { require: true, display: 'edit' } },
      deliveryDate: { '': { require: true, display: 'edit' } },
      materialGroup: { '': { require: true, display: 'edit' } },
      plant: { '': { require: true, display: 'edit' } },
      storageLocation: { '': { require: false, display: 'edit' } },
      purchasingOrg: { '': { require: true, display: 'edit' } },
      glAccountCode: { '': { require: false, display: 'hide' } },
      asset: { '': { require: false, display: 'hide' } },
      orderNo: { '': { require: false, display: 'hide' } },
      orderType: { '': { require: false, display: 'hide' } },
      costCenter: { '': { require: false, display: 'hide' } },
      wbsElement: { '': { require: false, display: 'hide' } },
      controllingArea: { '': { require: false, display: 'hide' } },
      profitCenter: { '': { require: false, display: 'hide' } },
      salesOrder: { '': { require: false, display: 'hide' } },
      salesOrderItemNo: { '': { require: false, display: 'hide' } },
      network: { '': { require: false, display: 'hide' } },
      productHierarchyLv2: { '': { require: false, display: 'hide' } },
      customer: { '': { require: false, display: 'hide' } },
      budgetType: { '': { require: true, display: 'edit' } },
      accountAssignment: { '': { require: true, display: 'edit' } }
    }, loading: false },
  formOrderGlAccount: { 
    id: 0, 
    orderNo: '', 
    glAccount: '', 
    active: true 
  },
  formWbsAsset: { 
    id: 0, 
    company: '', 
    wbsElementCode: '', 
    assetCode: '',
    assetType: '',
    active: true 
  }
}

export default createReducer(initial, state => ({
  [GET_MP_PURCHASING_GROUPS.REQUEST]: () => ({
    ...state,
    purchasingGroups: { data: [], loading: true }
  }),
  [GET_MP_PURCHASING_GROUPS.SUCCESS]: (data) => ({
    ...state,
    purchasingGroups: { data: data.data, loading: false }
  }),
  [GET_MP_COMPANY_PLANTS.REQUEST]: () => ({
    ...state,
    companyPlants: { data: [], loading: true }
  }),
  [GET_MP_COMPANY_PLANTS.SUCCESS]: (data) => ({
    ...state,
    companyPlants: { data: data.data, loading: false }
  }),
  [GET_COMPANY_DATA.REQUEST]: () => ({
    ...state,
    companyData: { data: {}, loading: true }
  }),
  [GET_COMPANY_DATA.SUCCESS]: (data) => ({
    ...state,
    companyData: { data: data.data, loading: false }
  }),
  [GET_MP_PLANT_STORAGE_LOCATIONS.REQUEST]: () => ({
    ...state,
    plantStorageLocations: { data: [], loading: true }
  }),
  [GET_MP_PLANT_STORAGE_LOCATIONS.SUCCESS]: (data) => ({
    ...state,
    plantStorageLocations: { data: data.data, loading: false }
  }),
  [GET_MP_PR_ITEM_FIELDS.REQUEST]: () => ({
    ...state,
    prItemFields: { data: state.prItemFields.data, loading: true }
  }),
  [GET_MP_PR_ITEM_FIELDS.SUCCESS]: (data) => ({
    ...state,
    prItemFields: { data: data.data, loading: false }
  }),
  [GET_MP_ORDER_GL_ACCOUNT.REQUEST]: (data) => ({
    ...state,
    orderGlAccounts: { data: data.withInactive ? state.orderGlAccounts.data : [], loading: true },
    allOrderGlAccounts: { data: data.withInactive ? [] : state.allOrderGlAccounts.data, loading: true },
  }),
  [GET_MP_ORDER_GL_ACCOUNT.SUCCESS]: (data) => ({
    ...state,
    orderGlAccounts: { data: data.withInactive ? state.orderGlAccounts.data : data.data, loading: false },
    allOrderGlAccounts: { data: data.withInactive ? data.data : state.allOrderGlAccounts.data, loading: false },
  }),
  [GET_MP_WBS_ASSETS.REQUEST]: (data) => ({
    ...state,
    wbsAssets: { data: data.withInactive ? state.wbsAssets.data : [], loading: true },
    allWbsAssets: { data: data.withInactive ? [] : state.allWbsAssets.data, loading: true },
  }),
  [GET_MP_WBS_ASSETS.SUCCESS]: (data) => ({
    ...state,
    wbsAssets: { data: data.withInactive ? state.wbsAssets.data : data.data, loading: false },
    allWbsAssets: { data: data.withInactive ? data.data : state.allWbsAssets.data, loading: false },
  }),
  [SET_FORM_ORDER_GL_ACCOUNT]: (data) => ({
    ...state,
    formOrderGlAccount: data.data || { id: 0, orderNo: '', glAccount: '', active: true }
  }),
  [GET_ASSET_TYPES.REQUEST]: () => ({
    ...state,
    assetTypes: { data: [], loading: true }
  }),
  [GET_ASSET_TYPES.SUCCESS]: (data) => ({
    ...state,
    assetTypes: { data: data.data, loading: false }
  }),
  [SET_FORM_WBS_ASSET]: (data) => ({
    ...state,
    formWbsAsset: data.data || { 
      id: 0, 
      company: '', 
      wbsElementCode: '', 
      assetCode: '',
      assetType: '',
      active: true 
    }
  }),
  [GET_ALL_WBS.REQUEST]: () => ({
    ...state,
    allWbs: { data: [], loading: true }
  }),
  [GET_ALL_WBS.SUCCESS]: (data) => ({
    ...state,
    allWbs: { data: data.data, loading: false }
  }),
}))
